import { Card, Row } from 'antd';
import { memo } from 'react';
import { IBaseProps } from 'src/types';

interface IProps extends IBaseProps {
  renderRight?: JSX.Element | React.ReactNode;
  title: string | JSX.Element | React.ReactNode;
  formSearch?: JSX.Element | React.ReactNode;
  paginate?: JSX.Element | React.ReactNode;
  extends?: JSX.Element | React.ReactNode;
}

function Container(props: IProps) {
  return (
    <Card bodyStyle={{ padding: '10px 20px', height: '100%', position: 'relative' }} style={{ height: '100%' }}>
      <Row justify="space-between" style={{ marginBottom: 12 }} align="middle">
        <h3>{props.title}</h3>
        <div>{props.renderRight}</div>
      </Row>
      {props.extends}
      <hr />
      {props.formSearch}
      {props.formSearch ? <hr /> : null}
      {props.children}
      <div style={{ position: 'absolute', left: 0, bottom: 0, right: 0, padding: '6px 0' }}>{props.paginate}</div>
    </Card>
  );
}

export default memo(Container);
